<script>
    import IntercomInit from "./_templates/IntercomInit.svelte";
    import MetaTags from "./_templates/MetaTags.svelte";
    import AuthorizedLayout from "./_templates/AuthorizedLayout.svelte";
    import AppBar from "$/components/AppBar.svelte";
    import Sidebar from "$/components/Sidebar.svelte";
    import Settings from "$/components/Settings.svelte";
    import SidePanel from "$/components/SidePanel.svelte";
    import WorkspaceSettingsPanel from "$/components/panels/WorkspaceSettingsPanel/WorkspaceSettingsPanel.svelte";
    import InvitationPanel from "$/components/panels/InvitationPanel/InvitationPanel.svelte";
    import ClusterPanel from "$/components/panels/ClusterPanel/ClusterPanel.svelte";
    import { AppStore, Panels } from "$/stores/AppStore";
    import UserSettingsPanel from "$/components/panels/UserSettingsPanel/UserSettingsPanel.svelte";

    import { beforeUrlChange } from "@roxi/routify"
    import { ActiveTopicStore } from "$/stores/extension/ActiveTopicStore";

    $beforeUrlChange((event, route) => {
        if(route.path !== '/:topicId'){
            ActiveTopicStore.clear();
        }
        return true
    })
</script>

<MetaTags></MetaTags>

<AuthorizedLayout>
    <div class="app_wrapper">
        <AppBar />
            
        <div id="pageWrapper" class="page_wrapper">
            <!-- IMPORTANT: When adding a new panel, if it's accessible on the copilot page, please also add it to /src/pages/copilot/index.svelte.  -->

            <Sidebar
                show={$AppStore.panel === Panels.SIDEPANEL}
                on:close={AppStore.closePanels}
            />
            
            <slot></slot>

            <SidePanel show={$AppStore.panel === Panels.SETTINGS}>
                <Settings standalone={true} on:close={AppStore.closePanels} />
            </SidePanel>

            <SidePanel show={$AppStore.panel === Panels.WORKSPACE}>
                <WorkspaceSettingsPanel
                    on:close={AppStore.closePanels}
                ></WorkspaceSettingsPanel>
            </SidePanel>

            <SidePanel show={$AppStore.panel === Panels.INVITATION}>
                <InvitationPanel
                    on:close={AppStore.closePanels}
                ></InvitationPanel>
            </SidePanel>

            <SidePanel show={$AppStore.panel === Panels.CLUSTER}>
                <ClusterPanel on:close={AppStore.closePanels}></ClusterPanel>
            </SidePanel>

            <SidePanel show={$AppStore.panel === Panels.USER_SETTINGS}>
                <UserSettingsPanel
                    on:close={AppStore.closePanels}
                ></UserSettingsPanel>
            </SidePanel>

            <!-- html element required to display toast messages-->
            <div id="toast" class="toast-wrapper"></div>

        </div>
    </div>

    <IntercomInit></IntercomInit>
</AuthorizedLayout>

<style>
    @import "../main.css";

    .app_wrapper {
        @apply flex h-dvh flex-col;
    }

    .page_wrapper {
        @apply relative z-10 flex flex-grow overflow-y-auto;
    }

    .toast-wrapper {
        @apply absolute left-0 right-0 z-50 flex h-0 w-full justify-center;
    }
</style>
